import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../logo.svg';
import { cx, FOCUS_RING } from '../components/styles';
import { CONTAINER, PRIMARY_CTA, SECONDARY_CTA } from './landingConfig';

/**
 * Section 11 (DESIGN_PLAN §1.10).
 *
 * ONLY PUBLIC ROUTES APPEAR HERE. `/setup` is deliberately absent: it lives
 * inside `MainLayout` and is auth-gated, so a signed-out click would bounce to
 * `/login`. `/help` covers the same ground publicly.
 */
const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: SECONDARY_CTA.label, to: SECONDARY_CTA.to },
      { label: PRIMARY_CTA.label, to: PRIMARY_CTA.to },
    ],
  },
  {
    title: 'Support',
    links: [{ label: 'Help & setup', to: '/help' }],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
    ],
  },
];

export const LandingFooter: React.FC = () => (
  <footer className="border-t border-white/10 py-12">
    <div className={cx(CONTAINER, 'grid grid-cols-2 gap-8 md:grid-cols-4')}>
      <div className="col-span-2 md:col-span-1">
        <div className="flex items-center gap-2.5">
          <Logo style={{ width: '28px', height: '28px' }} />
          <span className="text-base font-bold tracking-tight text-[#3b82f6]">FlashTools</span>
        </div>
        <p className="mt-4 text-sm text-white/50">Tools for people who sell tickets.</p>
        <p className="mt-2 text-xs text-white/30">© 2026 FlashTools</p>
      </div>

      {COLUMNS.map((column) => (
        <nav key={column.title} aria-label={column.title}>
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-white/30">
            {column.title}
          </p>
          <ul className="mt-2 space-y-0.5">
            {column.links.map((link) => (
              <li key={`${column.title}-${link.label}`}>
                <Link
                  to={link.to}
                  className={cx(
                    // inline-flex + min-height gives a real tap target: the bare
                    // text was 17px tall, well under the 44px touch guidance.
                    'inline-flex min-h-[40px] items-center rounded text-sm text-white/60',
                    'transition-colors hover:text-white',
                    FOCUS_RING,
                  )}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>
  </footer>
);
